import { render, staticRenderFns } from "./TypesProducts.vue?vue&type=template&id=96383aac"
import script from "./TypesProducts.vue?vue&type=script&lang=js"
export * from "./TypesProducts.vue?vue&type=script&lang=js"
import style0 from "./TypesProducts.vue?vue&type=style&index=0&id=96383aac&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96383aac')) {
      api.createRecord('96383aac', component.options)
    } else {
      api.reload('96383aac', component.options)
    }
    module.hot.accept("./TypesProducts.vue?vue&type=template&id=96383aac", function () {
      api.rerender('96383aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/products/TypesProducts.vue"
export default component.exports